// extracted by mini-css-extract-plugin
export default {"heading":"percentGoal_heading__uIKAU","gaugeBackground":"percentGoal_gaugeBackground__RiGPf"};